import { api } from "../config/api";

export const getCompanyInProgressJobs = async (companyId) => {
  const response = await api.get(`/InProgress/company/${companyId}`);
  return response.data;
};

// inprogressService.js
export const getFreelancerInProgressJobs = async (userId) => {
  const response = await api.get(`/inprogress/freelancer/${userId}`);
  // Verifique se response.data tem unreadMessages
  return response.data;
};

export const earlyExitJob = async (
  applicationId,
  { finishedOnTime, reason, freelancerPayment }
) => {
  const requestingUserId = localStorage.getItem("userId");

  const response = await api.put(
    `/InProgress/${applicationId}/early-exit`,
    {
      reason: finishedOnTime ? null : reason,
      requestingUserId,
      finishedOnTime,
      freelancerPayment,
    }
  );

  return response.data;
};

export const getJustFinishedJobs = async () => {
  const userId = localStorage.getItem("userId");
  const response = await api.get(`/InProgress/freelancer/${userId}/just-finished`);
  return response.data;
};

export const markOnTheWay = async (applicationId) => {
  const response = await api.put(`/InProgress/${applicationId}/on-the-way`);
  return response.data;
};

export const confirmArrival = async (applicationId, code) => {
  const response = await api.put(`/InProgress/${applicationId}/confirm-arrival`, { code });
  return response.data;
};

export const reportNoShow = async (applicationId) => {
  const response = await api.put(`/InProgress/${applicationId}/report-no-show`);
  return response.data;
};

export const extendTolerance = async (applicationId) => {
  const response = await api.put(`/InProgress/${applicationId}/extend-tolerance`);
  return response.data;
};

// inprogressService.js — só a função invalidateApplication muda
export const invalidateApplication = async (applicationId, bonusAmount = null) => {
  const response = await api.put(
    `/InProgress/${applicationId}/invalidate`,
    { bonusAmount }
  );
  return response.data;
};